// extracted by mini-css-extract-plugin
export default {"container":"Result_container__f4YqX","zeroResultContainer":"Result_zeroResultContainer__3D8dk","zeroResultText":"Result_zeroResultText__FWQnA"};